package com.upcominds.expedite.data.mobilelogs

actual object AppRuntimeInfoProvider {
    actual fun current(): AppRuntimeInfo = AppRuntimeInfo(
        platform = "WEB",
        loggingEnabled = false
    )
}
